import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import DurationInput from 'src/hook-form/duration-input';

interface Props {
  rules?: any;
  name: string;
  label: string;
  placeholder?: string;
  keyboardType?: string;
  required?: boolean;
  defaultValue?: string;
  helper?: string;
  render?: (props: any) => any;
}

const HookFormDurationInput = (props: Props) => {
  const {control} = useFormContext();

  return (
    <Controller
      control={control}
      rules={props.rules}
      render={({field, fieldState: {error}}) => (
        <DurationInput ref={field.ref} {...props} {...field} error={error} />
      )}
      name={props.name}
      defaultValue={props.defaultValue}
    />
  );
};

export default HookFormDurationInput;
